import { HardHat, ClipboardList, Headset, type LucideIcon } from "lucide-react";

export type Vacancy = {
  slug: string;
  icon: LucideIcon;
  title: string;
  location: string;
  type: string;
  department: string;
  hoursPerWeek: string;
  salaryIndication: string;
  shortDescription: string;
  intro: string;
  aboutRole: string[];
  responsibilities: string[];
  requirements: string[];
  offer: string[];
  aboutTeam: string;
};

export const VACANCIES: Vacancy[] = [
  {
    slug: "installatiemonteur-e",
    icon: HardHat,
    title: "Installatiemonteur E",
    location: "Regio Noord-Brabant",
    type: "Fulltime",
    department: "Elektrotechniek",
    hoursPerWeek: "36 – 40 uur",
    salaryIndication: "€ 2.800 – € 3.800 bruto p/m",
    shortDescription:
      "Als installatiemonteur E werk je zelfstandig aan elektrotechnische installaties bij particuliere en zakelijke klanten.",
    intro:
      "Houd jij van afwisseling, technisch puzzelen en wil je iedere dag tastbaar werk afleveren? Als installatiemonteur E bij Elvion Group Nederland draai je mee in een hecht team en lever je vakwerk waar onze klanten écht op rekenen. Van een nieuwe groepenkast in een woonhuis tot een complete elektra-installatie in een bedrijfspand.",
    aboutRole: [
      "Je werkt zelfstandig of samen met een collega op locatie bij particuliere en zakelijke klanten in heel Noord-Brabant.",
      "Geen dag is hetzelfde: storingen, nieuwbouw, renovatie, verbouw en service.",
      "Je krijgt een eigen servicebus mee, met daarin alle gereedschappen en materialen die je nodig hebt.",
    ],
    responsibilities: [
      "Aanleggen en aansluiten van elektrotechnische installaties volgens NEN 1010",
      "Vervangen van groepenkasten en uitbreiden van bestaande installaties",
      "Verhelpen van storingen en uitvoeren van onderhoud (NEN 3140)",
      "Installeren van slimme thermostaten, laadpalen en data-bekabeling",
      "Klanten te woord staan en adviseren over de mogelijkheden",
    ],
    requirements: [
      "Afgeronde opleiding Elektrotechniek niveau 2 of 3 (E) of vergelijkbaar",
      "Minimaal 2 jaar werkervaring als installatiemonteur",
      "NEN 3140 kennis is een pré",
      "Rijbewijs B",
      "Klantgericht en zelfstandig werken",
    ],
    offer: [
      "Salaris conform CAO Metaal & Techniek, schaal E",
      "Lease-auto ook privé beschikbaar",
      "Opleidingsbudget en doorgroeimogelijkheden",
      "Pensioen via PME",
      "25 vakantiedagen + 13 ADV-dagen",
    ],
    aboutTeam:
      "Je komt terecht in een team van 12 ervaren monteurs, met korte lijnen naar de werkvoorbereiding en planning. Iedere week sluiten we de week af met een gezamenlijke lunch op kantoor in Breda.",
  },
  {
    slug: "werkvoorbereider",
    icon: ClipboardList,
    title: "Werkvoorbereider",
    location: "Breda",
    type: "Fulltime",
    department: "Projectbeheersing",
    hoursPerWeek: "40 uur",
    salaryIndication: "€ 3.400 – € 4.800 bruto p/m",
    shortDescription:
      "Als werkvoorbereider ben je het schakelpunt tussen de klant, het uitvoeringsteam en de inkoper.",
    intro:
      "Als werkvoorbereider zorg jij dat ieder project soepel verloopt vóórdat de eerste monteur de bus instapt. Je vertaalt klantvraag en bestek naar een glasheldere werkomschrijving, calculatie en planning. Door jouw voorbereiding kunnen onze monteurs hun werk in één keer goed doen.",
    aboutRole: [
      "Je bent het centrale aanspreekpunt tijdens de voorbereidingsfase van je projecten.",
      "Je werkt nauw samen met de projectleider, de inkoper en de uitvoering.",
      "Hybride werken: 2 dagen vanuit huis, 3 dagen vanuit ons kantoor in Breda.",
    ],
    responsibilities: [
      "Opstellen van werkplannen, calculaties en materiaalstaten",
      "Aanvragen en beoordelen van offertes bij leveranciers",
      "Maken en bijhouden van de projectplanning",
      "Technische tekeningen uitwerken in AutoCAD",
      "Overdracht naar uitvoering en bewaken van scope en kosten",
    ],
    requirements: [
      "Afgeronde HBO-opleiding Werktuigbouwkunde, Elektrotechniek of vergelijkbaar",
      "Ervaring met werkvoorbereiding in de installatietechniek",
      "Vaardig in AutoCAD of vergelijkbare software",
      "Goede communicatieve vaardigheden",
      "Analytisch denkvermogen en oog voor detail",
    ],
    offer: [
      "Salaris tot € 4.800,- bruto per maand afhankelijk van ervaring",
      "Thuiswerkmogelijkheden",
      "Opleidingsbudget en persoonlijk ontwikkelplan",
      "Pensioen via PME",
      "25 vakantiedagen + 13 ADV-dagen",
    ],
    aboutTeam:
      "Je werkt in het projectbeheersingsteam van 5 collega's. We hebben een informele sfeer, veel ruimte voor eigen initiatief en investeren actief in jouw verdere ontwikkeling.",
  },
  {
    slug: "medewerker-binnendienst",
    icon: Headset,
    title: "Medewerker binnendienst",
    location: "Breda",
    type: "Fulltime / Parttime",
    department: "Klantenservice & Verkoop",
    hoursPerWeek: "24 – 40 uur",
    salaryIndication: "€ 2.600 – € 3.600 bruto p/m",
    shortDescription:
      "Als medewerker binnendienst ben je het eerste aanspreekpunt voor klanten en zorg je voor een uitstekende klantbeleving.",
    intro:
      "Jij bent de stem en het gezicht van Elvion Group Nederland aan de telefoon en in de mail. Met jouw enthousiasme en technische affiniteit help je klanten razendsnel verder, van een eenvoudige vraag tot een complete offerte voor een nieuwe installatie.",
    aboutRole: [
      "Je bent samen met 3 collega's verantwoordelijk voor alle inkomende klantcontacten.",
      "Je werkt nauw samen met onze adviseurs en monteurs in het veld.",
      "Flexibele werktijden en hybride werken behoren tot de mogelijkheden.",
    ],
    responsibilities: [
      "Klanten telefonisch en per mail te woord staan",
      "Offertes opstellen en orders verwerken in ons ERP-systeem",
      "Inplannen van service- en installatieafspraken",
      "Beheren van de mailbox en klantdossiers",
      "Signaleren van commerciële kansen en deze doorzetten naar de adviseurs",
    ],
    requirements: [
      "Afgeronde MBO-opleiding niveau 3 of 4, bij voorkeur in commerciële richting",
      "Ervaring in een commerciële binnendienstfunctie is een pré",
      "Technische affiniteit met elektrotechniek of beveiliging",
      "Uitstekende beheersing van Nederlands en Engels",
      "Klantgericht, proactief en stressbestendig",
    ],
    offer: [
      "Salaris tot € 3.600,- bruto per maand afhankelijk van ervaring",
      "Flexibele werktijden en hybride werken mogelijk",
      "Opleidingsbudget en interne trainingen",
      "Pensioen via PME",
      "25 vakantiedagen + 13 ADV-dagen",
    ],
    aboutTeam:
      "Het binnendienstteam is het kloppend hart van ons kantoor in Breda. Korte lijnen, veel humor en samen zorgen dat de klant met een glimlach ophangt.",
  },
];

export function getVacancyBySlug(slug: string): Vacancy | undefined {
  return VACANCIES.find((v) => v.slug === slug);
}
